/*
  Follow-along "Add to cart" — Premier Pool & Spa custom.
  Loaded on product pages only (layout/theme.liquid). Styles: assets/sticky-atc.css

  - PC (769px+): a compact card under the product photos (the photo column is already
    sticky, so the card stays in view with it).
  - Mobile: a slim bar along the bottom, ending short of the Tidio chat bubble.
  - Either one shows only while the page's real buy button is BELOW the screen
    (not visible on load, and not reached yet). Once the customer reaches it, or has
    scrolled past it, the follow-along button hides; scrolling back above brings it back.
  - It never adds to cart itself: it copies its quantity into the main form and clicks
    the real Add to cart button, so variants, Seal subscription choice, the cart drawer
    and tracking all behave exactly as they do with the main button.
  - Sold-out variant: becomes "Request a quote" and scrolls to the inline Tally box
    (#pps-quote-request); the box itself then becomes the "reached it" target.
  - TradeGrade / restricted items, pages without a buy button (spas, etc.) and quick
    view modals: nothing is added.
*/
(function (w, d) {
  'use strict';

  var MQ = w.matchMedia('(min-width: 769px)');

  function init() {
    var section = d.querySelector('.product-section[data-history="true"]');
    if (!section || section.__stickyAtc) return;
    if (section.querySelector('[data-restricted-item]')) return;
    var form = section.querySelector('form.product-single__form');
    var atc = form && form.querySelector('button[data-add-to-cart]');
    if (!atc) return;
    section.__stickyAtc = true;

    // getAttribute: the form has a field named "id" (variant select), which shadows form.id
    var formId = form.getAttribute('id');
    var qtyMain = (formId && d.querySelector('input[name="quantity"][form="' + formId + '"]')) ||
      form.querySelector('input[name="quantity"]');
    var priceEl = section.querySelector('[data-product-price]');
    var variantSelect = form.querySelector('select[data-product-select]');
    var multiVariant = !!(variantSelect && variantSelect.options.length > 1);
    var title = section.getAttribute('data-product-title') || '';
    var photoCol = section.querySelector('.product-single__sticky');

    // ---------- markup ----------
    function buildQty(cls) {
      var q = d.createElement('div');
      q.className = cls + '__qty';
      q.innerHTML =
        '<button type="button" class="' + cls + '__step" data-step="-1" aria-label="Decrease quantity">&minus;</button>' +
        '<input type="number" inputmode="numeric" min="1" value="1" aria-label="Quantity" class="' + cls + '__num">' +
        '<button type="button" class="' + cls + '__step" data-step="1" aria-label="Increase quantity">+</button>';
      return q;
    }

    // PC card
    var card = null;
    if (photoCol) {
      card = d.createElement('div');
      card.className = 'satc-card';
      card.hidden = true;
      card.innerHTML =
        '<div class="satc-card__info">' +
          '<div class="satc-card__title"></div>' +
          '<div class="satc-card__meta"><span class="satc-card__price"></span><span class="satc-card__variant"></span></div>' +
        '</div>' +
        '<div class="satc-card__actions"></div>';
      card.querySelector('.satc-card__title').textContent = title;
      var actions = card.querySelector('.satc-card__actions');
      if (qtyMain) actions.appendChild(buildQty('satc-card'));
      var cardBtn = d.createElement('button');
      cardBtn.type = 'button';
      cardBtn.className = 'btn satc-card__btn';
      actions.appendChild(cardBtn);
      photoCol.appendChild(card);
    }

    // Mobile bar
    var bar = d.createElement('div');
    bar.className = 'satc-bar';
    bar.hidden = true;
    bar.innerHTML = '<span class="satc-bar__price"></span><button type="button" class="btn satc-bar__btn"></button>';
    d.body.appendChild(bar);

    var btns = [bar.querySelector('.satc-bar__btn')];
    if (card) btns.push(card.querySelector('.satc-card__btn'));

    // ---------- state ----------
    var quoteBox = d.getElementById('pps-quote-request');
    function soldOut() { return atc.disabled; }
    function quoteVisible() { return !!(quoteBox && quoteBox.offsetParent); }
    function target() { return soldOut() && quoteVisible() ? quoteBox : atc; }

    function sync() {
      var out = soldOut();
      var label = out ? (quoteBox ? 'Request a quote' : 'Sold out') : 'Add to cart';
      var price = priceEl ? priceEl.textContent.trim() : '';
      btns.forEach(function (b) {
        b.textContent = label;
        b.classList.toggle('satc--quote', out);
        b.classList.toggle('btn--secondary', out);
        b.disabled = out && !quoteBox;
      });
      bar.querySelector('.satc-bar__price').textContent = price;
      if (card) {
        card.querySelector('.satc-card__price').textContent = price;
        var vt = '';
        if (multiVariant && variantSelect.selectedOptions[0]) {
          vt = variantSelect.selectedOptions[0].textContent.split(' - ')[0].trim();
        }
        card.querySelector('.satc-card__variant').textContent = vt ? ' · ' + vt : '';
        var q = card.querySelector('.satc-card__qty');
        if (q) q.hidden = out;
      }
      watchTarget();
    }

    // ---------- visibility ----------
    // A scroll check (once per frame) rather than IntersectionObserver: IO only reports
    // when the button crosses the screen edge, so a fast fling or anchor jump straight
    // past it would leave the follow-along button showing.
    var below = false; // real button / quote box is still below the bottom of the screen
    var watched = null;
    var frame = null;
    function check() {
      frame = null;
      if (!watched) return;
      below = watched.getBoundingClientRect().top > (w.innerHeight || d.documentElement.clientHeight);
      render();
    }
    function schedule() { if (!frame) frame = w.requestAnimationFrame(check); }
    function watchTarget() {
      watched = target();
      schedule();
    }
    w.addEventListener('scroll', schedule, { passive: true });
    w.addEventListener('resize', schedule);

    function overlayOpen() {
      var h = d.documentElement;
      return h.classList.contains('js-drawer-open') || h.classList.contains('modal-open');
    }

    function render() {
      var show = below && !overlayOpen();
      var desktop = MQ.matches;
      if (card) card.hidden = !(show && desktop);
      bar.hidden = !(show && !desktop);
    }

    // ---------- actions ----------
    function readQty(input) {
      var n = parseInt(input.value, 10);
      return n > 0 ? n : 1;
    }
    if (card && qtyMain) {
      var qInput = card.querySelector('.satc-card__num');
      qInput.value = readQty(qtyMain);
      card.addEventListener('click', function (e) {
        var s = e.target.closest('[data-step]');
        if (!s) return;
        qInput.value = Math.max(1, readQty(qInput) + parseInt(s.getAttribute('data-step'), 10));
      });
      qInput.addEventListener('change', function () { qInput.value = readQty(qInput); });
      qtyMain.addEventListener('change', function () { qInput.value = readQty(qtyMain); });
    }

    function scrollToEl(el) {
      var top = el.getBoundingClientRect().top + w.pageYOffset - 120;
      w.scrollTo({ top: top, behavior: 'smooth' });
    }

    function onClick(fromCard) {
      if (soldOut()) {
        if (quoteBox) {
          if (quoteVisible()) scrollToEl(quoteBox);
          else scrollToEl(form);
        }
        return;
      }
      if (fromCard && qtyMain && card) {
        qtyMain.value = readQty(card.querySelector('.satc-card__num'));
        qtyMain.dispatchEvent(new Event('change', { bubbles: true }));
      }
      atc.click();
    }
    btns[0].addEventListener('click', function () { onClick(false); });
    if (btns[1]) btns[1].addEventListener('click', function () { onClick(true); });

    // ---------- keep in step with the page ----------
    new MutationObserver(sync).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
    if (priceEl) new MutationObserver(sync).observe(priceEl, { childList: true, characterData: true, subtree: true });
    if (variantSelect) variantSelect.addEventListener('change', function () { setTimeout(sync, 0); });
    if (quoteBox) new MutationObserver(function () { setTimeout(sync, 0); }).observe(quoteBox, { attributes: true, attributeFilter: ['style'] });
    new MutationObserver(render).observe(d.documentElement, { attributes: true, attributeFilter: ['class'] });
    if (MQ.addEventListener) MQ.addEventListener('change', schedule); else MQ.addListener(schedule);

    sync();
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})(window, document);
